var React = require('react');

function HeartActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.24589 10.7241L8.82377 17.6565C10.0068 18.9032 11.9932 18.9032 13.1762 17.6565L19.7541 10.7241C22.082 8.27084 22.082 4.29327 19.7541 1.83997C17.4263 -0.613325 13.6521 -0.613323 11.3242 1.83997C11.148 2.02572 10.852 2.02572 10.6758 1.83997C8.34792 -0.613323 4.57374 -0.613324 2.24589 1.83997C-0.081963 4.29327 -0.0819616 8.27084 2.24589 10.7241Z","fill":"white"}));
}

HeartActive.defaultProps = {"width":"22","height":"19","viewBox":"0 0 22 19","fill":"none"};

module.exports = HeartActive;

HeartActive.default = HeartActive;
